import {YearQuarterEnum, YearSemesterEnum} from '@/types'
import dayjs from 'dayjs'

export const getQuarterFromMonth = (month: number): YearQuarterEnum => {
    if (month >= 9) return 'oct_dec'
    if (month >= 6) return 'jul_sep'
    if (month >= 3) return 'apr_jun'
    return 'jan_mar'
}

export const getSemesterFromMonth = (month: number): YearSemesterEnum => {
    return month < 6 ? 'jan_jun' : 'jul_dec'
}

export const getQuarterDateRange = (
    quarter: YearQuarterEnum,
    year: number
): {startDate: dayjs.Dayjs; endDate: dayjs.Dayjs} => {
    const ranges = {
        jan_mar: {
            startDate: dayjs().set('year', year).set('month', 0).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 2).endOf('month')
        },
        apr_jun: {
            startDate: dayjs().set('year', year).set('month', 3).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 5).endOf('month')
        },
        jul_sep: {
            startDate: dayjs().set('year', year).set('month', 6).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 8).endOf('month')
        },
        oct_dec: {
            startDate: dayjs().set('year', year).set('month', 9).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 11).endOf('month')
        }
    }
    return ranges[quarter]
}

export const getSemesterDateRange = (
    semester: YearSemesterEnum,
    year: number
): {startDate: dayjs.Dayjs; endDate: dayjs.Dayjs} => {
    const ranges = {
        jan_jun: {
            startDate: dayjs().set('year', year).set('month', 0).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 5).endOf('month')
        },
        jul_dec: {
            startDate: dayjs().set('year', year).set('month', 6).startOf('month'),
            endDate: dayjs().set('year', year).set('month', 11).endOf('month')
        }
    }
    return ranges[semester]
}
